<div *ngIf="loading$ | async" class="fixed w-full z-10">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<router-outlet></router-outlet>
